import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import {Container, Row, Col} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2Penalties.module.scss'
const cx = cn.bind(s)

interface IW2PenaltiesProps {
	className?: string
	content: IW2Content['penalties']
}

/** W2Penalties block component */
const W2Penalties: FC<IW2PenaltiesProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<div className={s.list}>
							{content?.items?.map((item) => (
								<div key={item._key || item.title} className={s.item}>
									<p className={cx('item__title', 'h3')}>{item.title}</p>
									<p className={s.itemDescription}>{item.description}</p>
								</div>
							))}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

W2Penalties.displayName = 'W2Penalties'

export default W2Penalties
